import { Box, Button, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import errorImage from '../../assets/images/AppError.jpg';
import Navbar from '../../layouts/Dashboard/components/Navbar/Navbar';
import styles from './ErrorBoundary.module.scss';

const ErrorBoundary = () => {
  const navigate = useNavigate();
  const t = useTranslations('errors');
  const appError = useRouteError() as Error;

  const handleNavigateToHome = () => {
    navigate('/', { replace: true });
  };

  useEffect(() => {
    window.document.title = `${t('boundary.documentTitle')} - CASA Retail AI`;
  }, [t]);

  // TEMP local debug: do not commit
  console.error('[ErrorBoundary] route error:', appError);
  // This should be logged
  // console.log({
  //   message: appError.message,
  //   name: appError.name,
  //   stack: appError.stack,
  //   cause: appError.cause,
  // });

  return (
    <Box id={styles.errorBoundary}>
      <Navbar onToggleSidebar={() => {}} hideSidebar />
      <Box className={styles.errorBoundaryBody}>
        <Box className={styles.errorImageContainer}>
          <img
            className={styles.errorImage}
            src={errorImage}
            alt={t('boundary.imageAlt')}
          />
        </Box>
        <Box className={styles.errorBoundaryInfo}>
          <Typography className={styles.errorBoundaryInfoTitle} variant='h3'>
            {t('boundary.title')}
          </Typography>
          <Typography
            className={styles.errorBoundaryInfoDescription}
            variant='body1'
            color='secondary'
          >
            {appError.message || t('app.somethingWentWrong')}
          </Typography>
          <Button size='large' onClick={handleNavigateToHome}>
            {t('backToHome')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
export default ErrorBoundary;
